import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTable } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationService } from "src/app/notifications/notification.service";
import { SessionService } from "src/app/session.service";
import { AreYouSureDialogComponent } from "src/app/shared/dialogs/are-you-sure-dialog/are-you-sure-dialog.component";
import { FilterTableDialogComponent } from "src/app/shared/dialogs/filter-table-dialog/filter-table-dialog.component";
import { UiService } from "src/app/ui/ui.service";
import { BroadcastService } from "../broadcast.service";
import { pageSizeOptions } from "src/app/shared/utils/pagination";
import { BehaviorSubject, merge, Observable, of, Subject } from "rxjs";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  first,
  switchMap,
  takeUntil,
  tap,
} from "rxjs/operators";
import { DataSource } from "@angular/cdk/table";
import { ElementLoaderDirective } from "src/app/ui/element-loader/element-loader.directive";
import { CollectionViewer } from "@angular/cdk/collections";
import { UtilService } from "src/app/util/util.service";
import { LocalStorageService } from "src/app/storage/local-storage.service";
@Component({
  selector: "app-broadcast-list",
  templateUrl: "./broadcast-list.component.html",
  styleUrls: ["./broadcast-list.component.scss"],
})
export class BroadcastListComponent implements OnInit {
  pageSizeOptions = pageSizeOptions;
  filterForm = new FormGroup({
    startDate: new FormControl(),
    endDate: new FormControl(),
  });
  searchValueControl = new FormControl("");
  columns = [
    { code: "name", name: "Name", filter: true, selected: true },
    { code: "created_at", name: "Created", filter: true, selected: true },
    { code: "send_date_time", name: "Date Sent", filter: true, selected: true },
    {
      code: "removal_date_time",
      name: "Date Removed",
      filter: true,
      selected: true,
    },
    { code: "audienceName", name: "Audience" },
    { code: "conversion_length", name: "Conversion Tracking" },
    { code: "options" },
  ];
  displayedColumns = this.columns.map((column) => column.code);
  perPage: number = 20;

  @ViewChild("broadcastsTable") broadcastsTable!: MatTable<any[]>;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  broadcasts: any;
  conversionTrackingOptions!: any;
  private onComponentDestroy = new Subject();
  broadcastsDataSource!: BroadcastsDataSource;
  @ViewChild(ElementLoaderDirective)
  broadcastElementLoader!: ElementLoaderDirective;
  onFilterColumnChange = new Subject();
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private Dialog: MatDialog,
    private BroadcastService: BroadcastService,
    private SessionService: SessionService,
    private NotificationService: NotificationService,
    private uiService: UiService,
    private ChangeDetectorRef: ChangeDetectorRef,
    private utilSvc: UtilService,
    private localStorageSvc: LocalStorageService,
  ) {}

  ngOnInit(): void {
    // this.initBroadcasts(this.activatedRoute.snapshot.data.broadcasts.records);

    // this.broadcastsDataSource = new MatTableDataSource(this.broadcasts);
    // this.broadcastsDataSource.filterPredicate = (data: any, filter: string) => {
    //   return this.filterPredicate(data, filter);
    // };
    this.perPage = this.localStorageSvc.pageSize || 20;

    this.conversionTrackingOptions = {
      "1_days": "Day 1",
      "2_days": "Day 2",
      "3_days": "Day 3",
      "4_days": "Day 4",
      "5_days": "Day 5",
      "6_days": "Day 6",
      "7_days": "Day 7",
      "2_weeks": "Week 2",
      "3_weeks": "Week 3",
      "4_weeks": "Week 4",
    };

    //TODO
    // this.filterForm.valueChanges
    //   .pipe(takeUntil(this.onComponentDestroy))
    //   .subscribe((changes) => {
    //     if (this.filterForm.valid) {
    //       let filteredBroadcasts;
    //       if (
    //         this.filterForm.controls.startDate.value &&
    //         this.filterForm.controls.endDate.value
    //       ) {
    //         filteredBroadcasts = this.broadcasts.filter((broadcast: any) => {
    //           return (
    //             new Date(broadcast.send_date_time) >=
    //               this.filterForm.controls.startDate.value.setHours(
    //                 0,
    //                 0,
    //                 0,
    //                 0,
    //               ) &&
    //             new Date(broadcast.send_date_time) <=
    //               this.filterForm.controls.endDate.value.setHours(23, 59, 59)
    //           );
    //         });
    //       } else if (this.filterForm.controls.startDate.value) {
    //         filteredBroadcasts = this.broadcasts.filter((broadcast: any) => {
    //           return (
    //             new Date(broadcast.send_date_time) >=
    //             this.filterForm.controls.startDate.value.setHours(0, 0, 0, 0)
    //           );
    //         });
    //       } else if (this.filterForm.controls.endDate.value) {
    //         filteredBroadcasts = this.broadcasts.filter((broadcast: any) => {
    //           return (
    //             new Date(broadcast.send_date_time) <=
    //             this.filterForm.controls.endDate.value.setHours(23, 59, 59)
    //           );
    //         });
    //       } else {
    //         filteredBroadcasts = this.broadcasts;
    //       }

    //       this.broadcastsDataSource = new MatTableDataSource(
    //         filteredBroadcasts,
    //       );
    //       this.broadcastsDataSource.filterPredicate = (
    //         data: any,
    //         filter: string,
    //       ) => {
    //         return this.filterPredicate(data, filter);
    //       };
    //       this.broadcastsTable.renderRows();
    //       this.broadcastsDataSource.paginator = this.paginator;

    //       this.broadcastsDataSource.sort = this.sort;
    //     }
    //   });
  }

  ngAfterViewInit() {
    // this.broadcastsTable.renderRows();
    // this.broadcastsDataSource.paginator = this.paginator;

    // this.broadcastsDataSource.sort = this.sort;

    this.broadcastsDataSource = new BroadcastsDataSource(
      this.BroadcastService,
      this.paginator,
      this.broadcastElementLoader,
    );

    this.loadBroadcastsPage().pipe(first()).subscribe();

    merge(
      this.sort.sortChange.pipe(tap(() => (this.paginator.pageIndex = 0))),
      this.paginator.page,
      this.onFilterColumnChange,
      this.searchValueControl.valueChanges.pipe(
        distinctUntilChanged(),
        tap(() => (this.paginator.pageIndex = 0)),
      ),
      this.filterForm.valueChanges.pipe(
        filter(() => {
          return (
            this.filterForm.valid &&
            this.filterForm.controls.startDate.value &&
            this.filterForm.controls.endDate.value &&
            this.filterForm.controls.startDate.value <
              this.filterForm.controls.endDate.value
          );
        }),
        tap(() => {
          this.filterForm.controls.startDate.value.setHours(0, 0, 0);
          this.filterForm.controls.endDate.value.setHours(23, 59, 59);
        }),
      ),
    )
      .pipe(
        debounceTime(300),
        switchMap(() => this.loadBroadcastsPage().pipe(first())),
        takeUntil(this.onComponentDestroy),
      )
      .subscribe();

    this.ChangeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  get currentAccount() {
    return this.SessionService.currentAccountValue!;
  }

  get currentApp() {
    return this.SessionService.currentAppValue!;
  }

  formatDate = (date: Date) => {
    return this.utilSvc.formatDate(date);
  }

  initBroadcasts(broadcasts: any[]) {
    const currDateTime = new Date().getTime();

    this.broadcasts = broadcasts.map((broadcast: any) => {
      const broadcastSentDateTime = new Date(
        broadcast.send_date_time,
      ).getTime();
      return {
        ...broadcast,
        audienceName: broadcast.audience?.name,
        hasBeenSent:
          !broadcast.scheduled || currDateTime >= broadcastSentDateTime,
      };
    });
  }

  loadBroadcastsPage() {
    const sort = this.buildSort();

    const startDate =
      this.filterForm.controls.startDate.valid &&
      this.filterForm.controls.startDate.value
        ? this.filterForm.controls.startDate.value.toISOString()
        : "1950-01-01T05:00:00.000Z";

    const endDate =
      this.filterForm.controls.endDate.valid &&
      this.filterForm.controls.endDate.value
        ? this.filterForm.controls.endDate.value.toISOString()
        : "3000-12-31T05:00:00.000Z";

    const facility_id = this.SessionService.selectedFacilities!.map(
      (facility) => {
        return facility.id;
      },
    );

    return this.broadcastsDataSource.loadBroadcasts(
      this.SessionService.currentAccountValue!.accountID,
      this.SessionService.currentAppValue!.id,
      {
        startDate,
        endDate,
        page: this.paginator.pageIndex,
        perPage: this.paginator.pageSize,
        facility_id,
        keyword: this.searchValueControl.value ?? "",
        listView: true,
        sort,
        forCount: true,
        filter_columns: this.columns
          .filter((column) => column.selected)
          .map((column) => column.code),
      },
    );
  }

  buildSort() {
    const sort = [];
    if (this.sort.direction.length) {
      sort.push(`${this.sort.active}:${this.sort.direction}`);
    }
    return sort;
  }

  // filterPredicate(data: any, filter: string) {
  //   let found = false;
  //   for (let column of this.selectedColumns) {
  //     let rowValue;
  //     if (column === "audience") {
  //       rowValue = data.filter_parameters?.name;
  //     } else if (column === "conversion_length") {
  //       rowValue = this.conversionTrackingOptions[data.conversion_length];
  //     } else {
  //       rowValue = data[column];
  //     }
  //     if (typeof rowValue === "number") {
  //       rowValue = rowValue.toString();
  //     }

  //     if (rowValue) {
  //       if (rowValue?.trim().toLowerCase().indexOf(filter) !== -1) {
  //         found = true;
  //       }
  //     }
  //   }

  //   return found;
  // }

  viewAudience(broadcast: any) {
    this.router.navigate(["broadcasts", "audiences", "view", broadcast.account_app_audience_id]);
  }

  sendBroadcast(broadcast: any) {
    this.router.navigate(["create"], {
      state: {
        audience: broadcast.account_app_audience_id,
      },
      relativeTo: this.activatedRoute.parent,
    });
  }

  edit(broadcast: any) {
    this.router.navigate([broadcast.id], {
      relativeTo: this.activatedRoute.parent,
    });
  }

  delete(broadcast: any) {
    this.Dialog.open(AreYouSureDialogComponent, {
      data: {
        areYouSureInfo: {
          description: `Are you sure you want to delete this broadcast ( ${broadcast.name} )?`,
        },
      },
    })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((res) => {
        if (res) {
          this.uiService
            .waitForEvent(
              this.BroadcastService.deleteBroadcast(
                this.currentAccount.accountID,
                this.currentApp.id,
                broadcast.id,
              ),
            )
            .pipe(takeUntil(this.onComponentDestroy))
            .subscribe(
              () => {
                this.NotificationService.openSuccessSnackBar(
                  "Broadcast deleted",
                );
                this.loadBroadcastsPage().subscribe();
                // this.broadcasts = this.broadcasts.filter(
                //   (broadcastItem: any) => {
                //     return broadcastItem.id !== broadcast.id;
                //   },
                // );

                // this.broadcastsDataSource = new MatTableDataSource(
                //   this.broadcasts,
                // );
                // this.broadcastsDataSource.filterPredicate = (
                //   data: any,
                //   filter: string,
                // ) => {
                //   return this.filterPredicate(data, filter);
                // };
                // this.broadcastsTable.renderRows();
                // this.broadcastsDataSource.paginator = this.paginator;

                // this.broadcastsDataSource.sort = this.sort;
              },
              () => {
                this.NotificationService.openErrorSnackBar(
                  "Error deleting broadcast",
                );
              },
            );
        }
      });
  }

  toggleFilterDialog() {
    this.Dialog.open(FilterTableDialogComponent, {
      data: {
        columns: this.columns,
      },
    })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((result) => {
        if (result) {
          this.columns = result;
          this.onFilterColumnChange.next();
        }
      });
  }

  createNewBroadcast() {
    this.router.navigate(["create"], {
      relativeTo: this.activatedRoute.parent,
    });
  }

  applyFilter() {
    //TODO
    // this.broadcastsDataSource.filter = this.searchValue.trim().toLowerCase();
    // if (this.broadcastsDataSource.paginator) {
    //   this.broadcastsDataSource.paginator.firstPage();
    // }
  }

  onPageChange(e: PageEvent){
    this.localStorageSvc.pageSize = e.pageSize;
    this.perPage = e.pageSize;
  }
}

export class BroadcastsDataSource implements DataSource<any> {
  private broadcastsSubject = new BehaviorSubject<any[]>([]);

  constructor(
    private BroadcastService: BroadcastService,
    private paginator: MatPaginator,
    private broadcastsElementLoader: ElementLoaderDirective,
  ) {}

  connect(collectionViewer: CollectionViewer): Observable<any[]> {
    return this.broadcastsSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer) {
    this.broadcastsSubject.complete();
  }

  loadBroadcasts(
    masterAccountID: number,
    accountAppID: number,
    queryParams: any,
  ) {
    return this.broadcastsElementLoader
      .waitForEvent(
        this.BroadcastService.getBroadcasts(
          masterAccountID,
          accountAppID,
          queryParams,
        ).pipe(catchError(() => of({ count: 0, records: [] }))),
      )
      .pipe(
        tap((filter: any) => {
          this.paginator.length = filter.count;
          this.broadcastsSubject.next(filter.records);
        }),
      );
  }
}
